import script from "./DualcarePage.vue?vue&type=script&setup=true&lang=js"
export * from "./DualcarePage.vue?vue&type=script&setup=true&lang=js"

import "./DualcarePage.vue?vue&type=style&index=0&id=346e59f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-346e59f6"]])

export default __exports__